import { setContext } from 'apollo-link-context'
import { ApolloLink } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { RetryLink } from 'apollo-link-retry'
import { InMemoryCache } from 'apollo-cache-inmemory'

export default ({ app, store, redirect, error, $config }) => {
  const headers = setContext(() => {
    return {
      headers: {
        Authorization: `bearer ${$config.strapiApiToken}`
      }
    }
  })

  const errorLink = onError(({ operation, graphQLErrors, networkError, forward }) => {
    console.log('networkError', networkError)
    console.log('graphQLErrors', graphQLErrors)

    if (networkError != null) {
      error({
        statusCode: 500
      })
    }
  })

  const retry = new RetryLink({
    delay: {
      initial: 100,
      max: 2000,
      jitter: true
    },
    attempts: {
      max: 3,
      retryIf: (error) => {
        const doNotRetryCodes = [500, 400, 401, 403, 429]
        return !!error && !doNotRetryCodes.includes(error.statusCode)
      }
    }
  })

  const link = ApolloLink.from([errorLink, headers, retry])

  return {
    link,
    httpEndpoint: $config.graphQlStrapiApi,
    cache: new InMemoryCache()
  }
}
